module.exports = __webpack_public_path__ + "assets/img/police.d0289dc0.png";